type SerializableMarker = { __type: string; value: any };

export class SerializeUtils {
  public static replacer(key: string, value: any): any {
    // Map -> { __type: 'Map', value: [ [k1,v1], [k2,v2], ... ] }
    if (value instanceof Map) {
      return { __type: 'Map', value: Array.from(value.entries()) };
    }
    // Set -> { __type: 'Set', value: [v1, v2, ...] }
    if (value instanceof Set) {
      return { __type: 'Set', value: Array.from(value.values()) };
    }
    // Date -> { __type: 'Date', value: ISOstring }
    if (value instanceof Date) {
      return { __type: 'Date', value: value.toISOString() };
    }
    return value;
  }

  public static reviver(key: string, value: any): any {
    if (value && typeof value === 'object' && '__type' in value) {
      const marker = value as SerializableMarker;
      switch (marker.__type) {
        case 'Map':
          return new Map(marker.value);
        case 'Set':
          return new Set(marker.value);
        case 'Date':
          return new Date(marker.value);
        default:
          return value;
      }
    }
    return value;
  }
}
